import React, { useEffect } from "react";
import { useVsiAppContext } from "../stores/VsiApp";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Grid from "./Grid";
import { useAuthWithRoute, useDebounce } from "../utils/hooks";
import { localShortDatePlusTimeFormatter } from "../utils/gridFormatters";

const logsDefinitions = [
	{
		"field": "user",
		"headerName": "User",
	},
	{
		"field": "client",
		"headerName": "Client",
	},
	{
		"field": "ip",
		"headerName": "IP",
	},
	{
		"field": "datetime",
		"headerName": "Timestamp",
        "cellRenderer": localShortDatePlusTimeFormatter,
        'sort': 'desc'
	},
	{
		"field": "error",
		"headerName": "Errors",
	},
	{
		"field": "emailStatus",
		"headerName": "Status",
	}
];

function AutobotLogsModal({
    isLogsModalOpen,
    toggleLogsModal
}) {
	const { theme } = useVsiAppContext();
	const [autobotLogs, {reFetchData: reFetchLogs}] = useAuthWithRoute(`/api/v6/admin/autobot_logs`);
    
    const debouncedModalOpen = useDebounce(isLogsModalOpen, 300);

    useEffect(() => {
        if (isLogsModalOpen && debouncedModalOpen) {
            reFetchLogs();
        }
    }, [debouncedModalOpen, isLogsModalOpen]);

    return (
        <Modal isOpen={isLogsModalOpen} toggle={toggleLogsModal} size={"xl"} className={`bg-${theme}`}>
            <ModalHeader toggle={toggleLogsModal} className={`bg-${theme} ${theme === 'dark' ? "text-light" : "text-dark"}`}>
                Custom Email Request Logs
            </ModalHeader>
            <ModalBody className={`bg-${theme} ${theme === 'dark' ? "text-light" : "text-dark"}`}>
                <Grid
                    addStyle
                    data={autobotLogs}
                    columnDefs={logsDefinitions} />
            </ModalBody>
            <ModalFooter className={`bg-${theme} ${theme === 'dark' ? "text-light" : "text-dark"}`}>
                <Button onClick={toggleLogsModal}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    )
};

export default withErrorBoundary(AutobotLogsModal, GeneralErrorBoundary);
